import axios from "axios";

import config from "./../config/env";

export const getAllDisciplines = () =>
  axios.get<{ disciplines: string[] }>(`${config.API}/disciplines`);
